import type { ReactNode } from "react"
import { cn } from "@/lib/utils"

// The sticky footer of a form screen: live status at the start, actions at the end.
//
// One bar owns both, so the answer to "why is Submit disabled?" is always sitting next to
// Submit. It sticks to the bottom of the scrollport (above the floating mobile nav below
// `md`), closes the column with a flat hairline, and stays inside the screen's content
// column — same anchored width as everything above it.
//
// Action hierarchy inside `children`, start → end: quiet escape (`ghost`), secondary verb
// (`secondary`), the one primary verb (default `Button`). Never two primaries.
export function ActionBar({
  status,
  children,
  className,
}: {
  /** Live form status — totals, imbalance, saved-draft chip. Silent on a pristine form. */
  status?: ReactNode
  children: ReactNode
  className?: string
}) {
  return (
    <div
      className={cn(
        "sticky bottom-0 z-10 flex flex-wrap items-center gap-x-6 gap-y-2 border-t border-border",
        "bg-background/95 py-3 backdrop-blur max-md:bottom-[4.5rem]",
        className,
      )}
    >
      {status ? <div className="min-w-0 flex-1 basis-64">{status}</div> : null}
      <div className="ms-auto flex shrink-0 flex-wrap items-center gap-2">{children}</div>
    </div>
  )
}
